import { SlidersHorizontal, ArrowDownUp } from 'lucide-react';

const desktopSplitBtn =
  'flex min-h-[52px] min-w-0 flex-1 items-center justify-center gap-2 px-5 py-3.5 text-[12px] font-extrabold uppercase tracking-wide text-surface-800 transition-colors hover:bg-surface-50 active:bg-surface-100 dark:text-surface-100 dark:hover:bg-surface-800/60 dark:active:bg-surface-800';

const ExploreFilterBar = ({ filterCount, onOpenSheet, onOpenSort }) => {
  const hasFilters = filterCount > 0;

  return (
    <div className="sticky top-16 z-30 -mx-3 border-y border-surface-200/80 bg-surface-50 px-3 py-2.5 dark:border-surface-800/60 dark:bg-surface-950 sm:-mx-6 sm:px-6 lg:mx-0 lg:border-0 lg:bg-transparent lg:px-0 lg:py-2 dark:lg:bg-transparent">
      {/* Mobile: split bar — Filter (left), Sort (right) */}
      <div className="flex overflow-hidden rounded-2xl border border-surface-200/90 bg-white shadow-sm dark:border-surface-700 dark:bg-surface-900 lg:hidden">
        <button
          type="button"
          onClick={onOpenSheet}
          aria-label={hasFilters ? `Filter, ${filterCount} active` : 'Filter'}
          className="flex flex-1 items-center justify-center gap-2 py-3.5 text-[12px] font-extrabold uppercase tracking-wide text-surface-800 transition-colors hover:bg-surface-50 active:bg-surface-100 dark:text-surface-100 dark:hover:bg-surface-800/60 dark:active:bg-surface-800"
        >
          <SlidersHorizontal size={18} strokeWidth={2} className="text-surface-600 dark:text-surface-300" />
          <span className="flex items-center gap-1.5">
            Filter
            {hasFilters ? (
              <span
                className="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-brand-500 px-1.5 text-[10px] font-extrabold tabular-nums leading-none text-white ring-2 ring-white dark:bg-brand-600 dark:ring-surface-900"
                aria-hidden
              >
                {filterCount > 99 ? '99+' : filterCount}
              </span>
            ) : null}
          </span>
        </button>
        <div className="w-px shrink-0 self-stretch bg-surface-200 dark:bg-surface-700" aria-hidden />
        <button
          type="button"
          onClick={onOpenSort}
          className="flex flex-1 items-center justify-center gap-2 py-3.5 text-[12px] font-extrabold uppercase tracking-wide text-surface-800 transition-colors hover:bg-surface-50 active:bg-surface-100 dark:text-surface-100 dark:hover:bg-surface-800/60 dark:active:bg-surface-800"
        >
          <ArrowDownUp size={18} strokeWidth={2} className="text-surface-600 dark:text-surface-300" />
          Sort
        </button>
      </div>

      {/* Desktop: split control — centered */}
      <div className="hidden lg:block">
        <div className="mx-auto flex w-full max-w-md overflow-hidden rounded-2xl border border-surface-200/90 bg-white shadow-md shadow-surface-900/5 ring-1 ring-black/[0.04] dark:border-surface-700 dark:bg-surface-900 dark:shadow-black/20 dark:ring-white/[0.06]">
          <button
            type="button"
            onClick={onOpenSheet}
            aria-label={hasFilters ? `Filter, ${filterCount} active` : 'Filter'}
            className={desktopSplitBtn}
          >
            <SlidersHorizontal size={18} strokeWidth={2} className="shrink-0 text-surface-600 dark:text-surface-300" />
            <span className="flex items-center gap-1.5">
              Filter
              {hasFilters ? (
                <span
                  className="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-brand-500 px-1.5 text-[10px] font-extrabold tabular-nums leading-none text-white ring-2 ring-white dark:bg-brand-600 dark:ring-surface-900"
                  aria-hidden
                >
                  {filterCount > 99 ? '99+' : filterCount}
                </span>
              ) : null}
            </span>
          </button>
          <div className="w-px shrink-0 self-stretch bg-surface-200 dark:bg-surface-700" aria-hidden />
          <button type="button" onClick={onOpenSort} className={desktopSplitBtn}>
            <ArrowDownUp size={18} strokeWidth={2} className="shrink-0 text-surface-600 dark:text-surface-300" />
            Sort
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExploreFilterBar;
